import validation from '../../../../../modules/Gull/Framework/validation.js';

const edit = {

	init() {

		// bij nieuwe dienstverlener_relatie
		if ($('select#dienstverlener_id').length) {
			// Toon en verberg connector wanner select wordt aangepast
			$('select#dienstverlener_id').change(function(e) {
				var dienstverlener_id = $(this).val();

				edit.toonCorrectConnectors(dienstverlener_id);
				// Draai functie die op basis van het type meldingen op de dienstverlender de melding type checkboxes activeerd
				edit.preSetTypeMelding(e);
			});

			$('select#dienstverlener_id').trigger('change');
		}

		// bij bestaande dienstverlener_relatie
		if ($('input#dienstverlener_id').length) {
			var dienstverlener_id = $('input#dienstverlener_id').val();
			edit.toonCorrectConnectors(dienstverlener_id);
		}

		// Toon en verberg formulier wanner de checkbox van een connector wordt aangevinkt
		$('input.connector-checkbox').change(function() {
			$(this).closest('.form-section').find('div').removeClass('d-none');
			if (!$(this).prop('checked')) {
				$(this).closest('.form-section').find('div').addClass('d-none').find('input,select').removeAttr('data-validate');
			} else {
				$(this).closest('.form-section').find('div').find('input,select').each(function() {
					$(this).attr('data-validate', $(this).attr('data-validate_org'));
				});
			}

			// Initialiseer validatie opnieuw
			$('input[data-validate],select[data-validate]').unbind('blur', validation.checkInputBlur);
			$('input[data-validate],select[data-validate]').blur(validation.checkInputBlur);
		});

		// Trigger change van checkbox zodat functie onpageload geinitieerd wordt
		$('input.connector-checkbox').trigger('change');

		// Bind functie die het contactpersoon veld aan en uit ziet wanneer checkbox wordt gewijzigd aan checkbox
		$('#gebruikAlsContactpersoon').on('change', function(e) {
			edit.toggleContactpersoon(e);
		});

	},


	// functie die het contactpersoon veld aan en uit ziet wanneer checkbox wordt gewijzigd
	toggleContactpersoon: function(e) {
		var targetEl = $('.form-section-contactpersoon-algemeen');
		targetEl.removeClass('d-none');
		if (!$(e.target).prop('checked')) {
			targetEl.addClass('d-none');
		}
	},

	// Functie die op basis van het type meldingen op de dienstverlender de melding type checkboxes activeerd
	preSetTypeMelding: function(e) {
		var typen = $(e.target).find('option:selected').data('melding-type') || [];
		$('input[type=checkbox][data-melding-type]').prop('checked', false);
		if (typeof typen === 'string') {
			typen = [typen];
		}
		$.each(typen, function(i, v) {
			$('input[type=checkbox][data-melding-type=' + v + ']').prop('checked', true);
		});
	},

	// Functie die op basis van het type meldingen op de dienstverlender de melding type checkboxes activeerd
	toonCorrectConnectors: function(dienstverlener_id) {
		if (dienstverlener_id === '' || typeof dienstverlener_id === 'undefined') {
			if (!$('div#connectors').hasClass('d-none')) {
				$('div#connectors').addClass('d-none');
			}

			if (!$('div.connector').hasClass('d-none')) {
				$('div.connector').addClass('d-none');
				$('div.connector :input').attr('disabled', true);
			}

			$('#btnSubmit').attr('disabled', true);
		} else {
			if ($('div#connectors').hasClass('d-none')) {
				$('div#connectors').removeClass('d-none');
			}

			$('div.connector').each(function() {
				if (!$(this).hasClass('d-none')) {
					$(this).addClass('d-none');
					$('div.connector :input,select').attr('disabled', true).removeAttr('data-validate');
				}
			});

			if ($('div#' + dienstverlener_id).hasClass('d-none')) {
				$('div#' + dienstverlener_id).removeClass('d-none');
				$('div#' + dienstverlener_id + ' :input,select').attr('disabled', false);
			}

			$('#btnSubmit').attr('disabled', false);
		}
	}


};

export default edit;

